export default __webpack_public_path__ + "static/media/gg5.7b76a5e0.jpeg";